import CancelablePromise from 'cancelable-promise';
import { ApiResult } from '../types/ApiResult';
import { StoreSlotsResponse } from '../types/StoreSlotsResponse';
import apiClient from './appApi';

export default function getStoreSlots(params: {
  appointmentTypeId: string;
  limit: number;
  shopNumber: string;
}): CancelablePromise<ApiResult<StoreSlotsResponse>> {
  return apiClient.post<ApiResult<StoreSlotsResponse>, {}>(
    '/CMSPages/SonovaBookAppointment/GetStoreSlots.ashx',
    params,
  );
}
